import { grpc, someGrpc } from "@somewear/grpc";
import { actionSetEpicHandlerBuilder } from "@somewear/model";
import { combineEpics } from "redux-observable";

import { organizationDeviceSettingsActions } from "./organizationWorkspaceDefaultSettings.slice";

const updateDefaultSettingsEpic = actionSetEpicHandlerBuilder(
	organizationDeviceSettingsActions.updateDefaultDeviceSettings,
	(payload) =>
		grpc.prepareRequestWithPayload(someGrpc.updateOrganizationDefaultSettings, payload.data),
	(payload) => {
		return {
			onFulfilled: "Successfully updated organization default settings",
			onPending: "",
			onRejected: "Could not update organization default settings",
		};
	},
);

const getDefaultSettingsEpic = actionSetEpicHandlerBuilder(
	organizationDeviceSettingsActions.getDefaultDeviceSettings,
	(payload) =>
		grpc.prepareRequestWithPayload(someGrpc.getOrganizationDefaultSettings, payload.data),
);

export const organizationDeviceSettingsEpics = combineEpics<any, any, any>(
	updateDefaultSettingsEpic,
	getDefaultSettingsEpic,
);
